// variants for growth_paywall_retrials experiment
export const VARIANT = 'variant'

// variants for growth_paywall_one_button experiment
export const VARIANT_1 = 'variant_1'
export const VARIANT_2 = 'variant_2'
